


















import UserSelector from "../../../components/generic/UserSelector/UserSelector.vue";
import { CaseTypePermission, RoleType } from "@/types/case/caseTypePermission";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import { Controllers, IsBadRequestResult, IsServerErrorResult } from "@infoland/iprova-api";
import storeHelper from "../../../store/store-helper";
import { UserItem } from "@/components/generic/UserSelector/types";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "DelegateToDo",
    props: {
        todoId: Number,
        caseTypeId: Number,
        subjectId: Number,
        toDoActorIDs: Array
    },
    components: { UserSelector },
    data: () => ({
        caseTypePermissions: null as CaseTypePermission[],
        userIDs: [] as string[],
        teamIDs: [] as string[],
        delegatedUser: null as UserItem[],
        isLoading: true as Boolean
    }),
    async created() {
        this.registerHandlers({ ok: this.delegateToDo });
    },
    computed: {},
    methods: {
        async initCaseTypePermissions(caseTypeId: number) {
            let route = `cases/case_types/${caseTypeId}/permissions?include_resolved_users=true&role_types=${RoleType.actor},${RoleType.coordinator}`;
            if (this.subjectId && this.subjectId != 0) {
                route = route + `&subject_ids=${this.subjectId}`;
            }
            this.caseTypePermissions = await Controllers.GenericController.getAsync<CaseTypePermission[]>(route);
            this.caseTypePermissions.forEach(x => {
                if (x.resolved_users?.length > 0) {
                    this.userIDs = this.userIDs.concat(
                        x.resolved_users.map(item => {
                            return item.user_id;
                        })
                    );
                }
                if (x.teams?.length > 0) {
                    this.teamIDs = this.teamIDs.concat(
                        x.teams.map(item => {
                            return item.team_id.toString();
                        })
                    );
                }
            });
            this.userIDs = this.userIDs.filter(x => x != storeHelper.userStore.loggedOnUser?.user_id && this.toDoActorIDs.indexOf(x) == -1);
            this.teamIDs = this.teamIDs.filter(x => this.toDoActorIDs.indexOf(x) == -1);

            this.isLoading = false;
        },
        async delegateToDo(): Promise<boolean> {
            if (this.delegatedUser && this.delegatedUser[0]) {
                const result = await Controllers.GenericController.patchAsync<object, string>(`cases/to_dos/${this.todoId}`, {
                    reassigned: { to_assignee_id: this.delegatedUser[0].assigneeId }
                });
                if (!IsBadRequestResult(result) && !IsServerErrorResult(result)) {
                    this.$router.push({ name: "Tasks" });
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
            }
            return true;
        }
    },
    watch: {
        caseTypeId: {
            handler(newValue, oldValue) {
                this.initCaseTypePermissions(newValue);
            },
            immediate: true
        },
        delegatedUser: {
            handler(newValue, oldValue) {
                if (newValue == null || !newValue.length) {
                    this.$emit("hide-ok-button", true);
                } else if (newValue[0].assigneeId != null) {
                    this.$emit("hide-ok-button", false);
                }
            },
            immediate: true
        }
    }
});
